import { shareReplay } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { AlertService } from "./AlertService/alert.service";
import { ApiService } from "src/app/services/api";

@Injectable({
  providedIn: "root",
})
export class CourseService {
  token = this.cookieService.get("token");
  storeId = this.cookieService.get("storeId");
  merchantId = this.cookieService.get("merchantId");
  isLoadingChangeSub = new Subject<boolean>();

  GLOBALURL: String;

  constructor(
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService,
    private toastr: AlertService,
    private ApiService: ApiService
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
  }

  // create item
  addNewCourse(newCoursePayload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .post(this.GLOBALURL + "/course", newCoursePayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.toastr.clear();
            this.toastr.error(response.message);
            this.isLoadingChangeSub.next(false);
          } else {
            this.toastr.clear();
            this.toastr.success(response.message);
            this.isLoadingChangeSub.next(false);
            this.router.navigate(["/menumanagement/courses"]);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.clear();
          this.toastr.error(message);
          this.isLoadingChangeSub.next(false);
        }
      );
  }

  // get item by id
  getCourse(courseId: string) {
    return this.http
      .get(this.GLOBALURL + "/course", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
        params: new HttpParams()
          .set("courseId", courseId)
          .set("storeId", this.storeId)
          .set("merchantId", this.merchantId),
      })
      .pipe(shareReplay(1));
  }

  // update item
  updateCourse(payload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .put(this.GLOBALURL + "/course", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: new HttpParams()
          .set("storeId", this.cookieService.get("storeId"))
          .set("merchantId", this.cookieService.get("merchantId")),
      })
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.toastr.clear();
            this.toastr.error(response.message);
            this.isLoadingChangeSub.next(false);
          } else {
            this.toastr.clear();
            this.toastr.success(response.message);
            this.isLoadingChangeSub.next(false);
            //this.router.navigate(["/menu/courses"]);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.clear();
          this.toastr.error(message);
          this.isLoadingChangeSub.next(false);
        }
      );
  }

  // update auto fire
  updateAutoFireStatus(payload) {
    // this.isLoadingChangeSub.next(true);
    return this.http.put(this.GLOBALURL + "/settings", payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
      params: new HttpParams().set(
        "storeId",
        this.cookieService.get("storeId")
      ),
      // .set("merchantId", this.cookieService.get("merchantId")),
    });
    // .subscribe(
    //   (response: any) => {
    //     if (response.success === 0) {
    // this.toastr.clear();
    //       this.toastr.error(response.message);
    //       this.isLoadingChangeSub.next(false);
    //     } else {
    // this.toastr.clear();
    //       this.toastr.success(response.message);
    //       this.isLoadingChangeSub.next(false);
    //       // this.router.navigate(["/menu/courses"]);
    //     }
    //   },
    //   (error) => {
    //     let message = error.error.message;
    //     if (
    //       message.includes(
    //         "Http failure response for (unknown url): 0 Unknown Error"
    //       )
    //     )
    //       message = "Please check the internet connection";
    //     this.toastr.error(message);
    //     this.isLoadingChangeSub.next(false);
    //   }
    // );
  }
}
